/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';
import type { AuditStatisticsDto } from './AuditStatisticsDto';
import {
    AuditStatisticsDtoFromJSON,
    AuditStatisticsDtoFromJSONTyped,
    AuditStatisticsDtoToJSON,
    AuditStatisticsDtoToJSONTyped,
} from './AuditStatisticsDto';

/**
 * 
 * @export
 * @interface AuditStatisticsResponse
 */
export interface AuditStatisticsResponse {
    /**
     * 
     * @type {string}
     * @memberof AuditStatisticsResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof AuditStatisticsResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof AuditStatisticsResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof AuditStatisticsResponse
     */
    timezoneMetadata?: TimezoneMetadata;
    /**
     * 
     * @type {AuditStatisticsDto}
     * @memberof AuditStatisticsResponse
     */
    data?: AuditStatisticsDto;
}

/**
 * Check if a given object implements the AuditStatisticsResponse interface.
 */
export function instanceOfAuditStatisticsResponse(value: object): value is AuditStatisticsResponse {
    return true;
}

export function AuditStatisticsResponseFromJSON(json: any): AuditStatisticsResponse {
    return AuditStatisticsResponseFromJSONTyped(json, false);
}

export function AuditStatisticsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuditStatisticsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
        'data': json['data'] == null ? undefined : AuditStatisticsDtoFromJSON(json['data']),
    };
}

export function AuditStatisticsResponseToJSON(json: any): AuditStatisticsResponse {
    return AuditStatisticsResponseToJSONTyped(json, false);
}

export function AuditStatisticsResponseToJSONTyped(value?: AuditStatisticsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
        'data': AuditStatisticsDtoToJSON(value['data']),
    };
}

